import {
  ASSIGN_SPECIALIST_VERIFY,
  ASSIGN_SPECIALIST_VERIFY_FAILURE,
  ASSIGN_SPECIALIST_VERIFY_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const assignSpecialistVerifyProviderReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ASSIGN_SPECIALIST_VERIFY:
      return { ...state, loading: true };
    case ASSIGN_SPECIALIST_VERIFY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case ASSIGN_SPECIALIST_VERIFY_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default assignSpecialistVerifyProviderReducer;
